import { useTranslation } from "next-i18next";
import { useState } from "react";

import { useTheme } from "@mui/material";

import { getColor } from "@hooks";

import { AreasContainer, BracketDark, BracketLight } from "./styles.styled";
import { WorkingAreaItem } from "./WorkingAreaItem";
import { AreaDef } from "./WorkingAreaItemContent";

export const WorkingAreas = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [opened, setOpened] = useState(0);

  const areas: AreaDef[] = [
    {
      label: t("about-us.blues-brackets.label"),
      title: t("about-us.blues-brackets.title"),
      desc: t("about-us.blues-brackets.description"),
      color:
        "linear-gradient(82.22deg, rgba(5, 223, 84, 0.24) 0%, rgba(150, 197, 240, 0.24) 76%)",
    },
    {
      label: t("about-us.embedded.label"),
      title: t("about-us.embedded.title"),
      desc: t("about-us.embedded.description"),
      color: getColor(c => c.tokens.casestudy.embedded.light, theme),
      borderColor: getColor(c => c.foundations.alpha.blue["alpha-24"], theme),
    },
    {
      label: t("about-us.development.label"),
      title: t("about-us.development.title"),
      desc: t("about-us.development.description"),
      color: getColor(c => c.tokens.casestudy.automation.light, theme),
      borderColor: getColor(c => c.foundations.alpha.purple["alpha-24"], theme),
    },
    {
      label: t("about-us.automation.label"),
      title: t("about-us.automation.title"),
      desc: t("about-us.automation.description"),
      color: getColor(c => c.tokens.casestudy.agile.light, theme),
      borderColor: getColor(c => c.foundations.alpha.teal["alpha-24"], theme),
    },
  ];

  return (
    <AreasContainer>
      {theme.palette.mode === "light" ? <BracketLight /> : <BracketDark />}

      {areas.map((area, index) => {
        return (
          <WorkingAreaItem
            key={index}
            area={area}
            areaIndex={index}
            openedIndex={opened}
            openTab={() => setOpened(index)}
            areasAmount={areas.length}
          />
        );
      })}
    </AreasContainer>
  );
};
